/**
 * Provide functions operating on "account" objects that are the result of queries to
 * backend get_account action.
 * @module services/accounts
 */

/**
 * Validates if the account is a master account
 * @returns {boolean}
 */
function isMasterAccount(account) {
  return account.master_id === 0 || account.master_id === account.account_id;
}

/**
 * Returns a list of strings that describe any issues that would lead an account to not
 * have an "Open" status.
 */
function statusDetails(account) {
  const checks = [
    (a) => (a.is_deactivated ? 'Account is hibernating' : ''),
    (a) => (a.is_deleted ? 'Account is deleted' : ''),
  ];
  if (!isMasterAccount(account)) {
    checks.push(
      (a) => (!a.parent.enabled ? 'Parent is disabled (failed payments/expired)' : ''),
      (a) => (a.parent.is_deactivated ? 'Parent is hibernating' : ''),
      (a) => (a.parent.is_deleted ? 'Parent is deleted' : ''),
    );
  } else {
    checks.push((a) => (!a.enabled ? 'Account is disabled (failed payments/expired)' : ''));
  }
  return checks.map((c) => c(account)).filter(Boolean);
}

/**
 * Shorthand for determining if an account is "Open", i.e. available for use.
 */
function isOpen(account) {
  return statusDetails(account).length === 0;
}

export default {
  isMasterAccount,
  isOpen,
  statusDetails,
};
